import styled, { css } from 'styled-components';

import { COLOR_THEME } from 'constants/colorThemes';
import ColormapInterface from 'shared-types/colormapinterface';
import { borderRadius, fontSize, fontWeight, getSpacing } from 'stylesheetB2b';

const ICON_FONT_SIZE = getSpacing(10);
const ICON_SIZE = getSpacing(5);
const ERROR_BORDER_WIDTH_IN_PX = 2;
const DEFAULT_BORDER_WIDTH_IN_PX = 1.5;

export const getButtonThemeStyle = (
  light: boolean,
  error: boolean,
  colorTheme: COLOR_THEME,
  colors: ColormapInterface,
) => {
  const primaryColor = error ? colors.error : colors[colorTheme].buttonPrimary;
  const secondaryColor = colors.buttonSecondary;

  return css`
    border: ${error ? ERROR_BORDER_WIDTH_IN_PX : DEFAULT_BORDER_WIDTH_IN_PX}px solid ${primaryColor};
    ${light
      ? css`
          background-color: ${secondaryColor};
          color: ${primaryColor};
        `
      : css`
          background-color: ${primaryColor};
          color: ${secondaryColor};
        `
    }
  `;
};

interface ButtonProps {
  light: boolean;
  error: boolean;
  colorTheme: COLOR_THEME;
  colors: ColormapInterface;
}

export const StyledButton = styled.button<ButtonProps>`
  border-radius: ${borderRadius.XXXLarge};
  display: flex;
  align-items: center;
  width: ${getSpacing(40)};
  height: ${getSpacing(7)};
  padding: 0;
  ${({ light, error, colorTheme, colors }) => getButtonThemeStyle(light, error, colorTheme, colors)}
`;
StyledButton.displayName = 'StyledButton';

export const IconContainer = styled.div`
  height: ${ICON_SIZE};
  width: ${ICON_SIZE};
  font-size: ${ICON_FONT_SIZE};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${getSpacing(2)};
`;
IconContainer.displayName = 'IconContainer';

export const TextContainer = styled.div<{ largeFont: boolean }>`
  text-align: center;
  font-weight: ${fontWeight.bold};
  flex: 1;
  font-size: ${fontSize.small};
`;

TextContainer.displayName = 'TextContainer';

export const IconContainerBam = styled(IconContainer)`
  font-size: ${getSpacing(1)};
`;
IconContainerBam.displayName = 'IconContainerBam';
